import { Component, OnDestroy } from '@angular/core';
import { BlogEntryStore } from '../blog/blog-entry-store';
import { BlogEntry } from '../blog/blog-entry';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnDestroy {

  public latestNews: BlogEntry[];

  public latestNewsSub: Subscription;

  constructor(blogEntryStore: BlogEntryStore) {
    this.latestNewsSub = blogEntryStore.entries
      .subscribe(x => this.updateLatestNews(x));
  }

  ngOnDestroy(): void {
    this.latestNewsSub.unsubscribe()
  }

  public getBlogEntryLink(entry: BlogEntry): string {
    let link = entry.link
      .find(v => v.rel === 'alternate');
    return link!.href;
  }

  private updateLatestNews(entries: BlogEntry[]) {
    this.latestNews = entries.slice(0, 3);
  }
}
